import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getCampaignLinkBySlug } from '../../services/musicLinkService';
import { saveClick } from '../../services/clickTrackingService';

const PLATFORMS = [
  {
    key: 'spotify',
    label: 'Spotify',
    urlKey: 'spotify_url',
    color: 'bg-[#1DB954] hover:bg-[#1aa34a]',
    textColor: 'text-white',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    ),
  },
  {
    key: 'apple_music',
    label: 'Apple Music',
    urlKey: 'apple_music_url',
    color: 'bg-gradient-to-r from-[#fc3c44] to-[#ff6b6b] hover:from-[#e0353c] hover:to-[#e85f5f]',
    textColor: 'text-white',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 00-1.877-.726 10.496 10.496 0 00-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026C4.786.07 4.043.15 3.34.428 2.004.958 1.04 1.88.475 3.208a5.485 5.485 0 00-.36 1.548c-.06.625-.077 1.252-.078 1.88v9.727c.01.55.02 1.1.076 1.648.157 1.52.68 2.85 1.77 3.93 1.02 1.01 2.27 1.54 3.67 1.72.47.06.94.08 1.41.09h9.73c.55-.01 1.1-.02 1.65-.08 1.52-.16 2.85-.68 3.93-1.77 1.01-1.02 1.54-2.27 1.72-3.67.06-.47.08-.94.09-1.41V7.87c-.01-.58-.02-1.16-.09-1.746zM12 17.5c-3.038 0-5.5-2.46-5.5-5.5S8.962 6.5 12 6.5s5.5 2.46 5.5 5.5-2.462 5.5-5.5 5.5zm6.5-9.75a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM12 8.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"/>
      </svg>
    ),
  },
  {
    key: 'youtube_music',
    label: 'YouTube Music',
    urlKey: 'youtube_music_url',
    color: 'bg-[#FF0000] hover:bg-[#cc0000]',
    textColor: 'text-white',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/>
      </svg>
    ),
  },
  {
    key: 'tiktok_sound',
    label: 'TikTok Sound',
    urlKey: 'tiktok_sound_url',
    color: 'bg-[#010101] hover:bg-[#333]',
    textColor: 'text-white',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z"/>
      </svg>
    ),
  },
];

const SmartLinkPage = () => {
  const { slug } = useParams();
  const [linkData, setLinkData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [clickedPlatform, setClickedPlatform] = useState(null);

  useEffect(() => {
    const fetchLink = async () => {
      if (!slug) {
        setNotFound(true);
        setLoading(false);
        return;
      }
      const { data, error } = await getCampaignLinkBySlug(slug);
      if (error || !data) {
        setNotFound(true);
      } else {
        setLinkData(data);
      }
      setLoading(false);
    };
    fetchLink();
  }, [slug]);

  const handlePlatformClick = async (platform) => {
    if (!linkData) return;
    setClickedPlatform(platform?.key);

    const url = linkData?.[platform?.urlKey];

    // Save click to Supabase before redirecting
    const clickPromise = saveClick({
      campaignId: linkData?.campaign_id,
      influencerId: linkData?.influencer_id,
      slug: linkData?.slug || linkData?.campaign_slug,
      platform: platform?.key,
      destinationUrl: url || '',
    });

    // Redirect after insert succeeds or after 3-second fallback timeout
    const timeoutPromise = new Promise((resolve) => setTimeout(resolve, 3000));
    await Promise.race([clickPromise, timeoutPromise]);

    if (url) {
      window.location.href = url;
    } else {
      setClickedPlatform(null);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white/60 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center px-4">
        <div className="text-center">
          <div className="text-6xl mb-4">🎵</div>
          <h1 className="text-2xl font-bold text-white mb-2">Link Not Found</h1>
          <p className="text-white/60">This music link doesn't exist or has been deactivated.</p>
        </div>
      </div>
    );
  }

  const availablePlatforms = PLATFORMS?.filter(p => linkData?.[p?.urlKey]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        {/* Cover Art */}
        <div className="flex flex-col items-center mb-8">
          {linkData?.cover_image_url ? (
            <img
              src={linkData?.cover_image_url}
              alt={`${linkData?.title} cover art`}
              className="w-48 h-48 rounded-2xl shadow-2xl object-cover mb-6"
            />
          ) : (
            <div className="w-48 h-48 rounded-2xl shadow-2xl bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center mb-6">
              <span className="text-6xl">🎵</span>
            </div>
          )}
          <h1 className="text-2xl font-bold text-white text-center leading-tight mb-1">
            {linkData?.title}
          </h1>
          {linkData?.artist_name && (
            <p className="text-white/60 text-sm text-center">{linkData?.artist_name}</p>
          )}
        </div>

        {/* Platform Buttons */}
        <div className="space-y-3">
          {availablePlatforms?.length === 0 ? (
            <p className="text-white/40 text-center text-sm">No streaming links available.</p>
          ) : (
            availablePlatforms?.map((platform) => (
              <button
                key={platform?.key}
                onClick={() => handlePlatformClick(platform)}
                disabled={clickedPlatform === platform?.key}
                className={`w-full flex items-center gap-4 px-5 py-4 rounded-2xl font-semibold text-base transition-all duration-200 ${platform?.color} ${platform?.textColor} shadow-lg active:scale-95 disabled:opacity-70`}
              >
                <span className="flex-shrink-0">{platform?.icon}</span>
                <span className="flex-1 text-left">
                  {clickedPlatform === platform?.key ? 'Opening...' : `Listen on ${platform?.label}`}
                </span>
                <svg className="w-4 h-4 opacity-60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            ))
          )}
        </div>

        {/* OzyMakers Branding */}
        <div className="mt-10 text-center">
          <p className="text-white/30 text-xs">
            Powered by{' '}
            <a href="https://ozymakers.com" className="text-white/50 hover:text-white/70 transition-colors">
              OzyMakers
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SmartLinkPage;
